import { Input, InputProps, Form } from "antd";
import { FormItemProps } from "antd/lib/form/FormItem";
import { useTranslations } from "../../../translations/translations";

interface Props extends FormItemProps {
	inputProps?: InputProps;
}

const HrNumberFormItem = ({ inputProps, ...props }: Props) => {
	const t = useTranslations();

	return (
		<Form.Item
			label={t.hrNumber}
			{...props}
			rules={[
				{
					type: "string",
					min: 3,
					max: 30,
					pattern: /^[0-9]*$/,
					message: t.fieldInvalid,
				},
				...(props.required
					? [
							{
								required: true,
								message: t.fieldRequired,
							},
					  ]
					: []),
				...(props.rules || []),
			]}
			validateFirst
		>
			<Input maxLength={30} placeholder={t.hrNumberPlaceholder} {...inputProps} />
		</Form.Item>
	);
};

export default HrNumberFormItem;
